import { Breadcrumbs, Stack, Title } from '@mantine/core'
import { FormattedMessage } from 'react-intl'
import { useLocation, useParams } from 'react-router'
import { useGetDeviceDetails } from '@/queries/deviceQueries'
import { RouterPath } from '@/router/paths'
import { PageWithFixedToolbar } from '../layout/PageWithFixedToolbar/PageWithFixedToolbar'
import { BreadcrumbLink } from '../ui-shared/Breadcrumbs/BreadcrumbLink'
import { BreadcrumbsSkeleton } from '../ui-shared/Breadcrumbs/BreadcrumbsSkeleton'
import { ErrorWithReload } from '../ui-shared/ErrorWithReload/ErrorWithReload'
import { DeviceGpuCharts } from './DeviceGpuCharts/DeviceGpuCharts'
import { DeviceInfo } from './DeviceInfo/DeviceInfo'
import { DeviceInfoSkeleton } from './DeviceInfo/DeviceInfoSkeleton'

export const DeviceDetailsPage = () => {
  const { deviceId } = useParams()
  const location = useLocation()

  const { deviceListParams } = (location.state || {}) as {
    deviceListParams?: string
  }

  const {
    data: device,
    isLoading,
    isError,
    refetch
  } = useGetDeviceDetails(deviceId || '', !!deviceId)

  return (
    <PageWithFixedToolbar
      toolbar={
        device ? (
          <Breadcrumbs>
            <BreadcrumbLink
              label={<FormattedMessage id="navLinks.devices" />}
              to={{
                pathname: RouterPath.devices,
                search: deviceListParams
              }}
            />

            <span>{device.label}</span>
          </Breadcrumbs>
        ) : (
          <BreadcrumbsSkeleton />
        )
      }
    >
      {isLoading && !device && <DeviceInfoSkeleton />}

      {isError && !device && (
        <ErrorWithReload onReload={() => void refetch()}>
          <FormattedMessage id="devices.data.error" />
        </ErrorWithReload>
      )}

      {device && (
        <Stack>
          <Title order={3}>{device.label}</Title>
          <DeviceInfo device={device} onActionSettled={() => void refetch()} />
          <DeviceGpuCharts device={device} />
        </Stack>
      )}
    </PageWithFixedToolbar>
  )
}
